import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { BehaviorSubject, Observable } from "rxjs";
import { environment } from "../../environments/environment";
import { distinctUntilChanged } from "rxjs/operators";

var headers_object = new HttpHeaders({
  "Content-Type": "application/json",
});
var headers_fileupload = new HttpHeaders({
  "content-type": "multipart/form-data",
});
const httpOptions = {
  headers: headers_object,
};
const httpOptionsUpload = {
  headers: headers_fileupload,
};
var headers_excel = new HttpHeaders({
  "Content-Type":
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //  'Content-Type':  'application/octet-stream',
  // responseType: 'text',
  responseType: "blob",
});
const httpOptionsexcel = {
  headers: headers_excel,
};
const csvRequestOptions: Object = {
  responseType: "text",
};

@Injectable({
  providedIn: "root",
})
export class ApiService {
  editCompanyindividualData: any;
  tableheader: any;
  Repaymenttableheader: any;
  RepaymenteditCompanyindividualData;

  baseURL = environment.baseURL;

  getAllCompanyBasesURL =
    this.baseURL + "/" + environment.getAllCompanyBasesList;
  CreateAllUserDetailsURL =
    this.baseURL + "/" + environment.CreateAllUserDetails;
  getUserURL = this.baseURL + "/" + environment.GetUserList;
  GetAllCompanyDetailsURL =
    this.baseURL + "/" + environment.GetAllCompanyDetails;
  GetAllproductgroupURL = this.baseURL + "/" + environment.GetAllproductgroup;
  GetBranchListValueURL = this.baseURL + "/" + environment.GetBranchListValue;
  GetDivisionValueURL = this.baseURL + "/" + environment.GetDivisionValue;
  GetDistrictListvalueURL =
    this.baseURL + "/" + environment.GetDistrictListvalue;
  GetAllTownShipvalueURL = this.baseURL + "/" + environment.GetAllTownShipvalue;
  GetAllCityTownvalueURL = this.baseURL + "/" + environment.GetAllCityTownvalue;
  GetAllAdvanceMerchantNoURL =
    this.baseURL + "/" + environment.GetAllAdvanceMerchantNo;
  UserTransactionModuleURL =
    this.baseURL + "/" + environment.UserTransactionModuleList;
  UserRoleTypeURL = this.baseURL + "/" + environment.UserRoleTypeList;
  GetUserNameFilterURL = this.baseURL + "/" + environment.GetUserNameFilterList;
  CreateIndividualDataURL =
    this.baseURL + "/" + environment.CreateIndividualData;
  GetAllTransferListURL = this.baseURL + "/" + environment.GetAllTransferList;
  GetAllReportListURL = this.baseURL + "/" + environment.ReportList;
  deleteTransTypeURL = this.baseURL + "/" + environment.deleteTransType;
  deleteUserDataURL = this.baseURL + "/" + environment.deleteUserData;
  deleteScheduleDataURL = this.baseURL + "/" + environment.deleteScheduleList;
  ServiceStatusCheckURL = this.baseURL + "/" + environment.ServiceStatus;
  UpdateTimeServiceURL = this.baseURL + "/" + environment.UpdateTimeService;
  CreateScheduleDetailsTimebaseURL =
    this.baseURL + "/" + environment.CreateScheduleDetailsTimebase;
  GetAddFiveNumberURL = this.baseURL + "/" + environment.GetAddFiveNumber;

  RefreshAddFiveNumberURL  = this.baseURL + "/" + environment.RefreshAddFiveNumber;

  ActivateAddFiveNumberURL =
    this.baseURL + "/" + environment.ActivateAddFiveNumber;
  GetIndividualWithAdvNoListURL =
    this.baseURL + "/" + environment.GetIndividualWithAdvNoList;

  loginURL = this.baseURL + "/" + environment.login;
  CompanyBaseUploadURL = this.baseURL + "/" + environment.UploadCompanyDetails;
  IndividualBaseUploadURL =
    this.baseURL + "/" + environment.UploadIndividualDetails;
  ChangePasswordURL = this.baseURL + "/" + environment.ChangePassword;
  UserRoleListURL = this.baseURL + "/" + environment.UserRoleList;
  UserModuleListURL = this.baseURL + "/" + environment.UserModuleList;
  sendOtpURL = this.baseURL + "/" + environment.SendOtp;
  verifyOtpURL = this.baseURL + "/" + environment.VerifyOtp;
  newpasswordURL = this.baseURL + "/" + environment.NewPassword;
  exporttoexcelURL = this.baseURL + "/" + environment.ExporttoExcel;
  exporttoexcelCompanyURL =
    this.baseURL + "/" + environment.ExporttoExcelCompany;
  exporttoexcelTransferURL =
    this.baseURL + "/" + environment.ExporttoExcelTransfer;
  exporttoexcelUserURL = this.baseURL + "/" + environment.ExporttoExcelUser;
  exporttoexcelReportURL = this.baseURL + "/" + environment.ExporttoExcelReport;
  BlockTransferURL = this.baseURL + "/" + environment.BlockTransfer;
  PasswordAuthURL = this.baseURL + "/" + environment.PasswordAuth;
  SearchURL = this.baseURL + "/" + environment.Search;
  GetAllGroupByCompanyListURL = this.baseURL + "/" + environment.GroupByCompany;
  GetAllGroupByTransferBaseListURL =
    this.baseURL + "/" + environment.GroupByTransferBase;
  GetAllGroupByDateListURL = this.baseURL + "/" + environment.GroupByDate;
  GetAllGroupByCompanySeparateListURL =
    this.baseURL + "/" + environment.GroupBycompanyonly;
  GetAllGroupByTransferBaseBothListURL =
    this.baseURL + "/" + environment.GroupByTransferBaseBoth;
  GetAllGroupByDateBothListURL =
    this.baseURL + "/" + environment.GroupByDateBoth;
  GetAllGroupByListURL = this.baseURL + "/" + environment.GroupByList;
  GetUserPasswordURL = this.baseURL + "/" + environment.GetUserPassword;
  foundIfDublicateByExcelURL =
    this.baseURL + "/" + environment.FoundIfDublicateByExcel;
  ProfilePicUploadURL = this.baseURL + "/" + environment.ProfilePicUpload;
  UpdateSuperAdminProfileImageURL =
    this.baseURL + "/" + environment.UpdateSuperAdminProfileImage;
  RemoveProfileImageURL = this.baseURL + "/" + environment.RemoveProfileImage;
  getBranchByPieChartURL =
    this.baseURL + "/" + environment.BranchBasedMethodByPieChart;
  getCompanyIndividualDataURL =
    this.baseURL + "/" + environment.CompanyIndividualData;
  getCompanyAutotransferDataURL =
    this.baseURL + "/" + environment.CompanyAutotransferData;
  getBranchDataURL =
    this.baseURL + "/" + environment.CompanyfilterOnlyBranchData;
  getTransferBaseURL =
    this.baseURL + "/" + environment.CompanyfilterTransferBaseData;
  IndividualBaseFilterURL =
    this.baseURL + "/" + environment.IndividualfilterDate;
  IndividualTransferDateURL =
    this.baseURL + "/" + environment.IndividualTransferFilterDate;
  BothTransTypeCPDateURL = this.baseURL + "/" + environment.BothTransTypeCP;
  BothTransTypeIBDateURL = this.baseURL + "/" + environment.BothTransTypeIB;
  BothScheduleTypeCPBDateURL =
    this.baseURL + "/" + environment.BothScheduleTypeCPB;
  BothScheduleTypeIBDateURL =
    this.baseURL + "/" + environment.BothScheduleTypeIB;
  BothBasedByGroupByAdminURL =
    this.baseURL + "/" + environment.BothBasedByGroupByAdmin;

  repaymentCompanyBaseUploadURL =
    this.baseURL + "/" + environment.repaymentUploadCompanyDetails;
  getAllRepaymentCompanyBasesURL =
    this.baseURL + "/" + environment.getAllRepaymentCompanyBase;
  repaymentexporttoexcelCompanyURL =
    this.baseURL + "/" + environment.repaymentExporttoExcelCompany;
  repaymentexporttoexcelTransferDetailsURL =
    this.baseURL + "/" + environment.repaymentExporttoExcelTransferDetails;
  GetAllDestinationNoURL =
    this.baseURL + "/" + environment.destinationNumberDropdown;
  GetAllSourceNoURL = this.baseURL + "/" + environment.sourceNumberDropdown;
  CreateRepaymentScheduleTranferDetails =
    this.baseURL + "/" + environment.CreateRepaymentScheduleTranferDetails;
  CreateRepaymentIndividualDataURL =
    this.baseURL + "/" + environment.createRepaymentIndividaulBase;

  GetAutoRepayTransferDetails =
    this.baseURL + "/" + environment.GetAllAutoRepayTransferDetails;
  GetPaymentTypeList = this.baseURL + "/" + environment.GetPaymentTypeList;
  GetAllRepaymentReportListURL =
    this.baseURL + "/" + environment.GetAllRepaymentReportList;
  repaymentexporttoexcelReportURL =
    this.baseURL + "/" + environment.repaymentexporttoexcelReports;
  exporttoexcelReportDownloadURL =
    this.baseURL + "/" + environment.ExporttoExcelReportDownload;

  repaymentDeleateTransferDetailsURL =
    this.baseURL + "/" + environment.DeleateTransferDetail;

  GetAllRepaymentGroupByCompanySeparateListURL =
    this.baseURL + "/" + environment.RepaymentGroupBycompanyonly;
  GetAllRepaymentGroupByTransferBaseBothListURL =
    this.baseURL + "/" + environment.RepaymentGroupByTransferBaseBoth;
  GetAllRepaymentGroupByDateBothListURL =
    this.baseURL + "/" + environment.RepaymentGroupByDateBoth;
  GetAllRepaymentBothBasedByGroupByAdminListURL =
    this.baseURL + "/" + environment.RepaymentBothBasedByGroupByAdmin;
  GetAllRepaymentGroupByCompanyListURL =
    this.baseURL + "/" + environment.RepaymentGroupByCompany;
  GetAllRepaymentGroupByTransferBaseListURL =
    this.baseURL + "/" + environment.RepaymentGroupByTransferBase;
  GetAllRepaymentGroupByDateListURL =
    this.baseURL + "/" + environment.RepaymentGroupByDate;

  RepayBothTransTypeCPDateURL =
    this.baseURL + "/" + environment.RepayBothTransTypeCP;
  RepayBothTransTypeIBDateURL =
    this.baseURL + "/" + environment.RepayBothTransTypeIB;
  RepayBothScheduleTypeCPBDateURL =
    this.baseURL + "/" + environment.RepayBothScheduleTypeCPB;
  RepayBothScheduleTypeIBDateURL =
    this.baseURL + "/" + environment.RepayBothScheduleTypeIB;
  RepaygetCompanyAutotransferDataURL =
    this.baseURL + "/" + environment.RepayCompanyAutotransferData;
  RepaygetBranchDataURL =
    this.baseURL + "/" + environment.RepayCompanyfilterOnlyBranchData;
  RepaygetTransferBaseURL =
    this.baseURL + "/" + environment.RepayCompanyfilterTransferBaseData;
  RepayIndividualBaseFilterURL =
    this.baseURL + "/" + environment.RepayIndividualfilterDate;
  RepayIndividualTransferDateURL =
    this.baseURL + "/" + environment.RepayIndividualTransferFilterDate;
  CompanyDashboardCardURL =
    this.baseURL + "/" + environment.CompanyDashboardCard;

  editCompanyData: any;
  private returnData = new BehaviorSubject<any>({});
  returnData$ = this.returnData.asObservable().pipe(distinctUntilChanged());
  constructor(private http: HttpClient) {}

  filterReturnData(predefinedFilterValue: any, groupByType: any) {
    this.returnData.next({
      predefinedvalue: predefinedFilterValue,
      groupByType: groupByType,
    });
  }

  RepayfilterReturnData(
    RepaypredefinedFilterValue: any,
    RepaygroupByType: any
  ) {
    this.returnData.next({
      RepayPredefinedvalue: RepaypredefinedFilterValue,
      RepayGroupByType: RepaygroupByType,
    });
  }

  getAllCompanyBases(params): Observable<any> {
    return this.http.post<any>(this.getAllCompanyBasesURL, params, httpOptions);
  }
  CreateAllUserDetails(params): Observable<any> {
    return this.http.post<any>(
      this.CreateAllUserDetailsURL,
      params,
      httpOptions
    );
  }
  getAllUser(params): Observable<any> {
    return this.http.post<any>(this.getUserURL, params, httpOptions);
  }
  GetAllCompanyDetails(params): Observable<any> {
    return this.http.post<any>(
      this.GetAllCompanyDetailsURL,
      params,
      httpOptions
    );
  }
  GetAllproductgroup(params): Observable<any> {
    return this.http.post<any>(this.GetAllproductgroupURL, params, httpOptions);
  }
  GetBranchListValue(params): Observable<any> {
    return this.http.post<any>(this.GetBranchListValueURL, params, httpOptions);
  }
  GetDivisionValue(params): Observable<any> {
    return this.http.post<any>(this.GetDivisionValueURL, params, httpOptions);
  }
  GetDistrictListvalue(params): Observable<any> {
    return this.http.post<any>(
      this.GetDistrictListvalueURL,
      params,
      httpOptions
    );
  }

  GetAllTownShipvalue(params): Observable<any> {
    return this.http.post<any>(
      this.GetAllTownShipvalueURL,
      params,
      httpOptions
    );
  }
  GetAllCityTownvalue(params): Observable<any> {
    return this.http.post<any>(
      this.GetAllCityTownvalueURL,
      params,
      httpOptions
    );
  }
  GetAllAdvanceMerchantNo(params): Observable<any> {
    return this.http.post<any>(
      this.GetAllAdvanceMerchantNoURL,
      params,
      httpOptions
    );
  }
  UserTransactionModule(): Observable<any> {
    return this.http.get<any>(this.UserTransactionModuleURL);
  }
  UserRoleType(): Observable<any> {
    return this.http.get<any>(this.UserRoleTypeURL);
  }
  GetUserNameFilter(): Observable<any> {
    return this.http.post<any>(this.GetUserNameFilterURL, httpOptions);
  }
  CreateAllIndividualData(params): Observable<any> {
    return this.http.post<any>(
      this.CreateIndividualDataURL,
      params,
      httpOptions
    );
  }
  GetAllTransferDetails(params): Observable<any> {
    return this.http.post<any>(this.GetAllTransferListURL, params, httpOptions);
  }
  GetAllReport(params): Observable<any> {
    return this.http.post<any>(this.GetAllReportListURL, params, httpOptions);
  }
  GetAllGroupByCompany(params): Observable<any> {
    return this.http.post<any>(
      this.GetAllGroupByCompanyListURL,
      params,
      httpOptions
    );
  }

  GetAllGroupByTransferBase(params): Observable<any> {
    return this.http.post<any>(
      this.GetAllGroupByTransferBaseListURL,
      params,
      httpOptions
    );
  }

  GetAllGroupByDate(params): Observable<any> {
    return this.http.post<any>(
      this.GetAllGroupByDateListURL,
      params,
      httpOptions
    );
  }

  GetAllGroupByCompanySeparateReport(params): Observable<any> {
    return this.http.post<any>(
      this.GetAllGroupByCompanySeparateListURL,
      params,
      httpOptions
    );
  }
  GetAllGroupByTransferBaseBoth(params): Observable<any> {
    return this.http.post<any>(
      this.GetAllGroupByTransferBaseBothListURL,
      params,
      httpOptions
    );
  }

  GetAllGroupByDateBoth(params): Observable<any> {
    return this.http.post<any>(
      this.GetAllGroupByDateBothListURL,
      params,
      httpOptions
    );
  }

  GetAllGroupByList(params): Observable<any> {
    return this.http.post<any>(this.GetAllGroupByListURL, params, httpOptions);
  }

  CreateScheduleDetailsTimebase(params): Observable<any> {
    return this.http.post<any>(
      this.CreateScheduleDetailsTimebaseURL,
      params,
      httpOptions
    );
  }

  GetIndividualWithAdvNoList(): Observable<any> {
    return this.http.post<any>(this.GetIndividualWithAdvNoListURL, httpOptions);
  }

  deleteTransTypeData(params): Observable<any> {
    return this.http.post<any>(this.deleteTransTypeURL, params, httpOptions);
  }
  deleteUserData(params): Observable<any> {
    return this.http.post<any>(this.deleteUserDataURL, params, httpOptions);
  }
  deleteScheduleData(params): Observable<any> {
    return this.http.post<any>(this.deleteScheduleDataURL, params, httpOptions);
  }

  ServiceStatusCheck(params): Observable<any> {
    return this.http.post<any>(this.ServiceStatusCheckURL, params, httpOptions);
  }

  UpdateTimeService(params): Observable<any> {
    return this.http.post<any>(this.UpdateTimeServiceURL, params, httpOptions);
  }

  getLogin(params): Observable<any> {
    return this.http.post<any>(this.loginURL, params, httpOptions);
  }

  FileUpload(fileToUpload: File): Observable<any> {
    const formData: FormData = new FormData();
    formData.append("file", fileToUpload);
    return this.http.post<any>(this.CompanyBaseUploadURL, formData);
    //.map(() => { return true; })
    //.catch((e) => this.handleError(e));
  }
  IndividualFileUpload(fileToUpload: File): Observable<any> {
    const formData: FormData = new FormData();
    formData.append("file", fileToUpload);
    return this.http.post<any>(this.IndividualBaseUploadURL, formData);
    //.map(() => { return true; })
    //.catch((e) => this.handleError(e));
  }

  GetAddFiveNumber(params): Observable<any> {
    return this.http.post<any>(this.GetAddFiveNumberURL, params, httpOptions);
  }

  RefreshAddFiveNumber(params): Observable<any> {
    return this.http.post<any>(
      this.RefreshAddFiveNumberURL,
      params,
      httpOptions
    );
  }

  ActivateAddFiveNumber(params): Observable<any> {
    return this.http.post<any>(
      this.ActivateAddFiveNumberURL,
      params,
      httpOptions
    );
  }

  ChangePassword(params): Observable<any> {
    return this.http.post<any>(this.ChangePasswordURL, params, httpOptions);
  }

  getAllUserUserRoleList(): Observable<any> {
    return this.http.get<any>(this.UserRoleListURL, httpOptions);
  }

  getAllUserModuleList(params): Observable<any> {
    return this.http.post<any>(this.UserModuleListURL, params, httpOptions);
  }

  // getAllUserModuleList(): Observable<any> {
  //   return this.http.get<any>(this.UserModuleListURL, httpOptions)
  // }
  ForgetpasswordSendOtp(params): Observable<any> {
    return this.http.post<any>(this.sendOtpURL, params, httpOptions);
  }
  ForgetpasswordVerifyOtp(params): Observable<any> {
    return this.http.post<any>(this.verifyOtpURL, params, httpOptions);
  }
  NewPassword(params): Observable<any> {
    return this.http.post<any>(this.newpasswordURL, params, httpOptions);
  }
  exporttoexcel(details: any): Observable<any> {
    return this.http.post<any>(this.exporttoexcelURL, details, httpOptions);
  }
  exporttoexcelCompany(details: any): Observable<any> {
    return this.http.post<any>(
      this.exporttoexcelCompanyURL,
      details,
      httpOptions
    );
  }
  exporttoexcelTransfer(details: any): Observable<any> {
    return this.http.post<any>(
      this.exporttoexcelTransferURL,
      details,
      httpOptions
    );
  }
  exporttoexcelUser(details: any): Observable<any> {
    return this.http.post<any>(this.exporttoexcelUserURL, details, httpOptions);
  }
  exporttoexcelReport(details: any): Observable<any> {
    return this.http.post<any>(
      this.exporttoexcelReportURL,
      details,
      httpOptions
    );
  }

  exporttoexcelReportDownload(details: any, options?: any): Observable<any> {
    return this.http.post<any>(
      this.exporttoexcelReportDownloadURL,
      details,
      options
    );
  }
  BlockNumber(params): Observable<any> {
    return this.http.post<any>(this.BlockTransferURL, params, httpOptions);
  }

  passwordAuth(params): Observable<any> {
    return this.http.post<any>(this.PasswordAuthURL, params, httpOptions);
  }

  Search(queryString: string): Observable<any> {
    return this.http.get<any>(this.SearchURL);
    //return this.http.post<any>(this.SearchURL, {search: queryString}, httpOptions)
  }

  foundIfDublicateByExcel(): Observable<any> {
    return this.http.get<any>(
      this.foundIfDublicateByExcelURL,
      csvRequestOptions
    );
  }

  getUserPassword(userId): Observable<any> {
    return this.http.post<any>(
      this.GetUserPasswordURL,
      { userId },
      httpOptions
    );
  }

  uploadProfilePicture(image: File): Observable<any> {
    const formData: FormData = new FormData();
    formData.append("image", image);
    return this.http.post<any>(this.ProfilePicUploadURL, formData);
  }

  UpdateSuperAdminProfileImage(params): Observable<any> {
    return this.http.post<any>(
      this.UpdateSuperAdminProfileImageURL,
      params,
      httpOptions
    );
  }

  RemoveProfileImageById(params): Observable<any> {
    return this.http.post<any>(this.RemoveProfileImageURL, params, httpOptions);
  }
  getBranchBasedByPieChart(params): Observable<any> {
    return this.http.post<any>(
      this.getBranchByPieChartURL,
      params,
      httpOptions
    );
  }

  getBothCompanyIndividualData(params): Observable<any> {
    return this.http.post<any>(
      this.getCompanyIndividualDataURL,
      params,
      httpOptions
    );
  }

  getCompanyAutotransferData(params): Observable<any> {
    return this.http.post<any>(
      this.getCompanyAutotransferDataURL,
      params,
      httpOptions
    );
  }
  getCompanyfilterOnlyBranchData(params): Observable<any> {
    return this.http.post<any>(this.getBranchDataURL, params, httpOptions);
  }
  getCompanyfilterTransferBaseData(params): Observable<any> {
    return this.http.post<any>(this.getTransferBaseURL, params, httpOptions);
  }

  IndividualfilterData(params): Observable<any> {
    return this.http.post<any>(
      this.IndividualBaseFilterURL,
      params,
      httpOptions
    );
  }

  IndividualTransferfilterDate(params): Observable<any> {
    return this.http.post<any>(
      this.IndividualTransferDateURL,
      params,
      httpOptions
    );
  }
  BothTransTypeCPFilterDate(params): Observable<any> {
    return this.http.post<any>(
      this.BothTransTypeCPDateURL,
      params,
      httpOptions
    );
  }
  BothTransTypeIBFilterDate(params): Observable<any> {
    return this.http.post<any>(
      this.BothTransTypeIBDateURL,
      params,
      httpOptions
    );
  }
  BothScheduleTypeCPBFilterDate(params): Observable<any> {
    return this.http.post<any>(
      this.BothScheduleTypeCPBDateURL,
      params,
      httpOptions
    );
  }

  BothScheduleTypeIBFilterDate(params): Observable<any> {
    return this.http.post<any>(
      this.BothScheduleTypeIBDateURL,
      params,
      httpOptions
    );
  }
  BothBasedByAdmin(params): Observable<any> {
    return this.http.post<any>(
      this.BothBasedByGroupByAdminURL,
      params,
      httpOptions
    );
  }

  // //////////////////AUTO REPAYMENT///////////////////////////////

  repaymentFileUpload(fileToUpload: File): Observable<any> {
    const formData: FormData = new FormData();
    formData.append("file", fileToUpload);
    return this.http.post<any>(this.repaymentCompanyBaseUploadURL, formData);
    //.map(() => { return true; })
    //.catch((e) => this.handleError(e));
  }

  getAllRepaymentCompanyBases(params): Observable<any> {
    return this.http.post<any>(
      this.getAllRepaymentCompanyBasesURL,
      params,
      httpOptions
    );
  }

  repaymentexporttoexcelCompany(details: any): Observable<any> {
    return this.http.post<any>(
      this.repaymentexporttoexcelCompanyURL,
      details,
      httpOptions
    );
  }
  repaymentExporttoExcelTransferDetails(details: any): Observable<any> {
    return this.http.post<any>(
      this.repaymentexporttoexcelTransferDetailsURL,
      details,
      httpOptions
    );
  }

  GetAllDestinationNo(params): Observable<any> {
    return this.http.post<any>(
      this.GetAllDestinationNoURL,
      params,
      httpOptions
    );
  }

  GetAllSourceNo(params): Observable<any> {
    return this.http.post<any>(this.GetAllSourceNoURL, params, httpOptions);
  }

  CreateRepaymentTranferDetails(params): Observable<any> {
    return this.http.post<any>(
      this.CreateRepaymentScheduleTranferDetails,
      params,
      httpOptions
    );
  }
  CreateAllRepaymentIndividualData(params): Observable<any> {
    return this.http.post<any>(
      this.CreateRepaymentIndividualDataURL,
      params,
      httpOptions
    );
  }

  GetAllAutoRepayTransferDetails(params): Observable<any> {
    return this.http.post<any>(
      this.GetAutoRepayTransferDetails,
      params,
      httpOptions
    );
  }

  GetPaymentTypeLists(): Observable<any> {
    return this.http.get<any>(this.GetPaymentTypeList, csvRequestOptions);
  }

  // Repayment-Reports

  GetAllRepaymentReport(params): Observable<any> {
    return this.http.post<any>(
      this.GetAllRepaymentReportListURL,
      params,
      httpOptions
    );
  }
  repaymentExporttoExcelReport(details: any): Observable<any> {
    return this.http.post<any>(
      this.repaymentexporttoexcelReportURL,
      details,
      httpOptions
    );
  }

  repaymentDeleateTransferDetails(details: any): Observable<any> {
    return this.http.post<any>(
      this.repaymentDeleateTransferDetailsURL,
      details,
      httpOptions
    );
  }

  GetAllRepaymentGroupByCompanySeparate(details: any): Observable<any> {
    return this.http.post<any>(
      this.GetAllRepaymentGroupByCompanySeparateListURL,
      details,
      httpOptions
    );
  }

  GetAllRepaymentGroupByTransferBaseBoth(details: any): Observable<any> {
    return this.http.post<any>(
      this.GetAllRepaymentGroupByTransferBaseBothListURL,
      details,
      httpOptions
    );
  }

  GetAllRepaymentGroupByDateBoth(details: any): Observable<any> {
    return this.http.post<any>(
      this.GetAllRepaymentGroupByDateBothListURL,
      details,
      httpOptions
    );
  }

  GetAllRepaymentBothBasedByGroupByAdmin(details: any): Observable<any> {
    return this.http.post<any>(
      this.GetAllRepaymentBothBasedByGroupByAdminListURL,
      details,
      httpOptions
    );
  }

  GetAllRepaymentGroupByCompany(details: any): Observable<any> {
    return this.http.post<any>(
      this.GetAllRepaymentGroupByCompanyListURL,
      details,
      httpOptions
    );
  }

  GetAllRepaymentGroupByTransferBase(details: any): Observable<any> {
    return this.http.post<any>(
      this.GetAllRepaymentGroupByTransferBaseListURL,
      details,
      httpOptions
    );
  }

  GetAllRepaymentGroupByDate(details: any): Observable<any> {
    return this.http.post<any>(
      this.GetAllRepaymentGroupByDateListURL,
      details,
      httpOptions
    );
  }

  RepayBothTransTypeCPFilterDate(params): Observable<any> {
    return this.http.post<any>(
      this.RepayBothTransTypeCPDateURL,
      params,
      httpOptions
    );
  }

  RepayBothTransTypeIBFilterDate(params): Observable<any> {
    return this.http.post<any>(
      this.RepayBothTransTypeIBDateURL,
      params,
      httpOptions
    );
  }

  RepayBothScheduleTypeCPBFilterDate(params): Observable<any> {
    return this.http.post<any>(
      this.RepayBothScheduleTypeCPBDateURL,
      params,
      httpOptions
    );
  }
  RepayBothScheduleTypeIBFilterDate(params): Observable<any> {
    return this.http.post<any>(
      this.RepayBothScheduleTypeIBDateURL,
      params,
      httpOptions
    );
  }
  RepaygetCompanyAutotransferData(params): Observable<any> {
    return this.http.post<any>(
      this.RepaygetCompanyAutotransferDataURL,
      params,
      httpOptions
    );
  }
  RepaygetCompanyfilterOnlyBranchData(params): Observable<any> {
    return this.http.post<any>(this.RepaygetBranchDataURL, params, httpOptions);
  }

  RepaygetCompanyfilterTransferBaseData(params): Observable<any> {
    return this.http.post<any>(
      this.RepaygetTransferBaseURL,
      params,
      httpOptions
    );
  }

  RepayIndividualfilterData(params): Observable<any> {
    return this.http.post<any>(
      this.RepayIndividualBaseFilterURL,
      params,
      httpOptions
    );
  }
  RepayIndividualTransferfilterDate(params): Observable<any> {
    return this.http.post<any>(
      this.RepayIndividualTransferDateURL,
      params,
      httpOptions
    );
  }

  CompanyDashboardCard(params): Observable<any> {
    return this.http.post<any>(
      this.CompanyDashboardCardURL,
      params,
      httpOptions
    );
  }
}
